import { Space } from "@mantine/core";
import React from "react";
import SettingsHeader from "./components/SettingsHeader";

const SettingsLayout: React.FC = ({ children }) => (
  <div style={{ padding: "26px 40px" }}>
    <SettingsHeader />
    <Space h="xl" />
    <div>{children}</div>
  </div>
);

export default SettingsLayout;
